import z from 'zod';

export const EventScopeType = {
    Judgeable: 'Judgeable',
    Judging: 'Judging',
    Editable: 'Editable',
    HeadJudgeable: 'HeadJudgeable',
} as const;
export type EventScopeType = (typeof EventScopeType)[keyof typeof EventScopeType];

export const EventScopeEnum = z.enum(EventScopeType);
